export default "__VITE_ASSET__CeCqe$sO__"